type SocialProvider = 'google' | 'apple'

type SocialAuthHandlers = {
  signInWithGoogle: (idToken: string) => Promise<void>
  signInWithApple: (params: {
    identityToken: string
    user?: { name?: { firstName?: string; lastName?: string } }
  }) => Promise<void>
}

export async function signInWithSocialProvider(
  provider: SocialProvider,
  handlers: SocialAuthHandlers,
  credential?: string
) {
  if (provider === 'google') {
    if (!credential) {
      throw new Error('Google login token missing')
    }

    await handlers.signInWithGoogle(credential)
    return
  }

  const AppleID = (window as any).AppleID?.auth
  if (!AppleID) {
    throw new Error('Apple Sign In SDK not loaded')
  }

  AppleID.init({
    clientId: import.meta.env.VITE_APPLE_CLIENT_ID || 'com.certiauthentic.web',
    scope: 'name email',
    redirectURI: window.location.origin,
    usePopup: true,
  })

  const data = await AppleID.signIn()

  await handlers.signInWithApple({
    identityToken: data.authorization.id_token,
    user: {
      name: {
        firstName: data.user?.name?.firstName,
        lastName: data.user?.name?.lastName,
      },
    },
  })
}
